import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './action-button.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class ActionButton extends s {
    constructor() {
        super(...arguments);
        this.id = '';
        this.text = '';
        this.href = '';
        this.buttonTemplate = '';
        this.additionalClasses = '';
        this.ariaLabel = '';
        this.marginBottom = '1em';
    }
    render() {
        const buttonClassNames = getStyleClassNames({
            marginBottom: this.marginBottom,
            additionalClasses: this.additionalClasses.concat(' ', this.buttonTemplate),
        });
        return $ `<a class="action-button-link" id="${this.id}" href="${this.href}" aria-label="${this.ariaLabel}"><div class="action-button-container ${buttonClassNames}"><span class="action-button-name"><slot></slot></span></div></a>`;
    }
}
ActionButton.styles = css_248z;
__decorate([
    e({ type: String })
], ActionButton.prototype, "id", void 0);
__decorate([
    e({ type: String })
], ActionButton.prototype, "text", void 0);
__decorate([
    e({ type: String })
], ActionButton.prototype, "href", void 0);
__decorate([
    e({ type: String })
], ActionButton.prototype, "buttonTemplate", void 0);
__decorate([
    e({ type: String })
], ActionButton.prototype, "additionalClasses", void 0);
__decorate([
    e({ type: String })
], ActionButton.prototype, "ariaLabel", void 0);
__decorate([
    e({ type: String })
], ActionButton.prototype, "marginBottom", void 0);
customElements.define('action-button', ActionButton);

export { ActionButton };
